import { gql } from '@apollo/client';
import { TRANSLATED_STRING_FIELDS } from '@assets/i18n/config';

export const FETCH_INTEGRATIONS = gql`
  query fetchIntegrations($input: FetchIntegrationsInput!) {
    fetchIntegrations(input: $input) {
      integrations {
        id
        configuration
        provider
        type
        state
        scope
        passthroughApiUrl
        passthroughApiPrivateSecretName
        organization {
          id
          translatedName { ${TRANSLATED_STRING_FIELDS} }
          parent {
            id
            translatedName { ${TRANSLATED_STRING_FIELDS} }
          }
        }
      }
      totalCount
    }
  }
`;
